import React from "react";
import { Helmet } from "react-helmet";
import {
  BUSINESS_NAME,
  BUSINESS_CONTACT_EMAIL,
  BUSINESS_CONTACT_PHONE,
} from "@/core/constants/business";
import { META, generateLocationsRichSnippet } from "./meta";
import Hero from "./Hero";
import Main from "./Main";
import CTA from "./CTA";

const LocationsPage: React.FC = () => {
  const richSnippet = generateLocationsRichSnippet();

  // Store location data
  const locationData = {
    name: `${BUSINESS_NAME} DC`,
    address: {
      street: "3400 Connecticut Avenue NW",
      city: "Washington",
      state: "DC",
      zip: "20008",
    },
    coordinates: {
      lat: 38.9332,
      lng: -77.058606,
    },
    phone: BUSINESS_CONTACT_PHONE,
    email: BUSINESS_CONTACT_EMAIL,
    hours: {
      weekdays: "10:00 AM - 8:00 PM",
      weekend: "10:00 AM - 8:00 PM",
    },
    googleMapsUrl: `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
      "3400 Connecticut Avenue NW, Washington, DC"
    )}`,
  };

  return (
    <>
      <Helmet>
        <title>{META.title}</title>
        <meta name="description" content={META.meta_description} />
        <meta name="keywords" content={META.keywords} />
        <link
          rel="canonical"
          href={`https://slsdispensary.com${META.canonicalUrl}`}
        />

        {/* OpenGraph Meta Tags */}
        <meta property="og:title" content={META.title} />
        <meta property="og:description" content={META.meta_description} />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content={`https://slsdispensary.com${META.canonicalUrl}`}
        />
        <meta
          property="og:image"
          content="https://slsdispensary.com/images/street-lawyer-services-dc-dispensary-entrance.jpg"
        />
        <meta property="og:site_name" content={BUSINESS_NAME} />

        {/* JSON-LD for rich snippets */}
        <script type="application/ld+json">
          {JSON.stringify(richSnippet)}
        </script>
      </Helmet>

      {/* Hero Section */}
      <Hero googleMapsUrl={locationData.googleMapsUrl} />

      {/* Main Content Section */}
      <Main locationData={locationData} />

      {/* CTA Section */}
      <CTA googleMapsUrl={locationData.googleMapsUrl} />
    </>
  );
};

export default LocationsPage;
